import React from 'react';

import type { Library } from '@/shared/types';

import type { ModuleTarget } from '@/entities/langserver/api/types';

import { LibraryManager } from '@/widgets/workbench/LibraryManager';

import styles from './LibraryCell.module.css';

type LibraryCellProps = {
  target: ModuleTarget;
  clientId: string;
  installedLibraries: Library[];
  availableLibraries: string[];
  uploadedModules: string[];
  libraryDisplayNames?: Record<string, string>;
  onInstall: (library: string, libraryInfo?: { type: 'custom' | 'standard'; content?: string }) => void;
  onUninstall: (library: string) => void;
  readOnly?: boolean;
  onFileUpload?: (fileName: string, fileContent: string) => void;
  onExecutionFilesUpdate?: (files: Record<string, string>) => void;
  executionFiles?: Record<string, string>;
  onLibraryLog?: (message: string) => void;
};

export const LibraryCell: React.FC<LibraryCellProps> = ({
  target,
  clientId,
  installedLibraries,
  availableLibraries,
  uploadedModules,
  libraryDisplayNames = {},
  onInstall,
  onUninstall,
  readOnly = false,
  onFileUpload,
  onExecutionFilesUpdate,
  executionFiles,
  onLibraryLog,
}) => {
  return (
    <div className={styles.libraryCell}>
      <div className={styles.libraryCellScroll}>
        <LibraryManager
          target={target}
          clientId={clientId}
          installedLibraries={installedLibraries}
          availableLibraries={availableLibraries}
          uploadedModules={uploadedModules}
          libraryDisplayNames={libraryDisplayNames}
          onInstall={onInstall}
          onUninstall={onUninstall}
          disabled={readOnly}
          onFileUpload={onFileUpload}
          onExecutionFilesUpdate={onExecutionFilesUpdate}
          executionFiles={executionFiles}
          onLibraryLog={onLibraryLog}
        />
      </div>
    </div>
  );
};
